import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRespuesta, ApiRespuestaPaginada } from '@app/models/ApiRespuesta.interface';

import { catchError, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { handleError } from '../tools/handle-error';
import { EventoPersonalI } from '@app/interfaces/general/evento-personal';

@Injectable({
    providedIn: 'root'
})
export class EventosPersonalesService {
    private url = environment.url + 'eventos-personales';
    private readonly http = inject(HttpClient);

    insert(evento: EventoPersonalI) {
        return this.http.post<ApiRespuesta<EventoPersonalI>>(this.url, evento).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    getAll(params?: HttpParams) {
        const url = `${this.url}/get/all`;
        return this.http.get<ApiRespuestaPaginada<EventoPersonalI>>(url, { params }).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    update(evento: EventoPersonalI) {
        const url = `${this.url}/${evento.id}`;
        return this.http.put<ApiRespuesta<EventoPersonalI>>(url, evento).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }
}
